import { render } from "./HeroBackgroundCommon.vue?vue&type=template&id=40a46bb2&ts=true"
import script from "./HeroBackgroundCommon.vue?vue&type=script&lang=ts"
export * from "./HeroBackgroundCommon.vue?vue&type=script&lang=ts"

import "./HeroBackgroundCommon.vue?vue&type=style&index=0&id=40a46bb2&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__